// store
export const DELETE_TOKEN = 'DELETE_TOKEN';
export const LOADING = 'LOADING';
export const SET_TOKEN = 'SET_TOKEN';

// auth
export const SET_USER = 'SET_USER';

// product
export const SET_PRODUCT = 'SET_PRODUCT';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_OFERTAS = 'SET_OFERTAS';
export const SET_CART = 'SET_CART';
export const ADDTOCART = 'ADDTOCART';
export const REMOVEFROMCART = 'REMOVEFROMCART';
export const SET_CANTIDAD = 'SET_CANTIDAD';
export const DISMINUIR_CANTIDAD = 'DISMINUIR_CANTIDAD';
export const AUMENTAR_CANTIDAD = 'AUMENTAR_CANTIDAD';
export const CLEAR_CART = 'CLEAR_CART';

// labs
export const SET_LABORATORIOS = 'SET_LABORATORIOS';

// pedidos
export const SET_PEDIDOS = 'SET_PEDIDOS';
export const SET_PAGE_COUNT = 'SET_PAGE_COUNT';
